/* oxlint-disable no-console */

import { baseGlobals } from '@root/typescript/baseGlobals'

type TParams = unknown[]

interface ILogger {
  readonly log: (...params: TParams) => void
  readonly test: (...params: TParams) => void
  readonly dev: (...params: TParams) => void
  readonly prod: (...params: TParams) => void
}

export default class Logger implements ILogger {
  public isEnabled = true
  private readonly ns: string

  /**
   * Logger példányosítása.
   * @param ns - Namespace, ahol logolunk.
   */
  public constructor (ns: string) {
    this.ns = ns
  }

  /**
   * Csak fejlesztéskor módban logolhat.
   * @param params - A logolandó paraméterek.
   */
  public static dev (...params: TParams): void {
    if (baseGlobals.isDev && !baseGlobals.isTest) {
      console.log(...params)
    }
  }

  /**
   * Minden körülmények között logolhat.
   * @param params - A logolandó paraméterek.
   */
  public log (...params: TParams): void {
    this.logIt(...params)
  }

  /**
   * Csak tesztkörnyezetben logolhat.
   * @param params - A logolandó paraméterek.
   */
  public test (...params: TParams): void {
    if (baseGlobals.isTest) {
      this.logIt(...params)
    }
  }

  /**
   * Csak fejlesztéskor logolhat.
   * @param params - A logolandó paraméterek.
   */
  public dev (...params: TParams): void {
    if (baseGlobals.isDev && !baseGlobals.isTest) {
      this.logIt(...params)
    }
  }

  /**
   * Ez productionben ÉS fejlesztéskor is logol.
   * @param params - A logolandó paraméterek.
   */
  public prod (...params: TParams): void {
    if (baseGlobals.isProd || baseGlobals.isDev) {
      this.logIt(...params)
    }
  }

  /**
   * Console.log -ra, namespace után logol.
   * @param params - A logolandó paraméterek.
   */
  private logIt (...params: TParams): void {
    if (this.isEnabled) {
      console.log(`[${ this.ns }]`, ...params)
    }
  }
}
